import useAuth from 'hooks/useAuth';
import { useInfiniteQuery, useMutation, useQuery } from 'react-query';
import { dispatch } from 'store';
import { openSnackbar } from 'store/slices/snackbar';
import { Pagination } from 'types/api';
import { ISubUser } from 'types/user';
import {
    TGetBalance,
    TInforWithdraw,
    TNewAddress,
    TSubUserBalance,
    TSubUserIdOfMerchant,
    TTransferDataSubmit,
    TWithdrawDataSubmit,
    Wallet
} from 'types/wallet';
import axiosServices from 'utils/axios';

const useWalletApi = (props: {
    symbol?: string;
    userId?: string;
    callBack?: (data?: any) => void;
    keyword?: string;
    page?: number;
    size?: number;
    enableWallet?: boolean;
    merchantId?: number | string | null;
    enableGetPrice?: boolean;
    chart?: boolean;
    networkId?: string;
    coin?: string;
}) => {
    const { user } = useAuth();

    const {
        symbol = '',
        userId,
        callBack,
        keyword = '',
        size = 20,
        page = 0,
        enableWallet = false,
        merchantId = user?.id,
        enableGetPrice = false,
        chart = false,
        networkId = '',
        coin
    } = props;

    const qGetFunding = useInfiniteQuery(
        [`qGetFunding_${symbol}_${page}_${size}_${keyword}_${merchantId}_${chart}`, page, size, symbol, keyword, merchantId, chart],
        () =>
            axiosServices.get(
                `/v1/wallet/getFundings?page=${page}&size=${size}&keyword=${keyword}&symbol=${symbol}&merchantId=${merchantId}`
            ),
        {
            enabled: Boolean(merchantId) || chart,
            refetchOnWindowFocus: false
        }
    );
    const qGetFundingSubUser = useQuery(
        [`qGetFunding_${symbol}_${keyword}_${userId}`, page, size, keyword, userId],
        () =>
            axiosServices.get(
                `/v1/wallet/getFundings?subUserId=${userId}&page=${page}&size=${size}&keyword=${keyword}&merchantId=${merchantId}`
            ),
        {
            enabled: Boolean(userId)
        }
    );

    const qGetBalance = useQuery(
        [`qGetBalance_${merchantId}`],
        () => axiosServices.get(`/v1/wallet/showBalance?subUser=&merchantId=${merchantId}`),
        {
            enabled: Boolean(merchantId),
            refetchOnWindowFocus: false,
            onSuccess(data: any) {},
            onError(error: any) {}
        }
    );

    const qGetBalanceSubUser = useQuery(
        ['qGetBalanceSubUser', userId],
        () => axiosServices.get(`/v1/wallet/showBalance?subUserId=${userId}`),
        {
            enabled: Boolean(userId),
            onSuccess(data: any) {},
            onError(error: any) {}
        }
    );

    const qGetInfoWithdraw = useQuery(
        ['qGetInfoWithdraw', symbol, networkId],
        () => axiosServices.get(`/v1/withdraw/getWithdrawInfo/${networkId}/${symbol}`),
        {
            enabled: Boolean(symbol) && Boolean(networkId) && enableWallet,
            onSuccess(data: any) {},
            onError(error: any) {}
        }
    );
    const qGetAddress = useQuery(['qGetAddress', symbol], () => axiosServices.get(`/v1/deposit/getAddress/${symbol}`), {
        enabled: Boolean(symbol) && enableWallet,
        onSuccess(data: any) {},
        onError(error: any) {}
    });
    const mGetAddress = useMutation((symbolName: string) => axiosServices.get(`/v1/deposit/getAddress/${symbolName}`), {
        onSuccess(data: any, variables, context) {
            // callBack?.();
            // dispatch(
            //     openSnackbar({
            //         open: true,
            //         message: 'Withdraw submit order successfully',
            //         variant: 'alert',
            //         alert: {
            //             color: 'success'
            //         },
            //         close: true,
            //         anchorOrigin: {
            //             vertical: 'bottom',
            //             horizontal: 'right'
            //         }
            //     })
            // );
        },
        onError(error: any) {
            // dispatch(
            //     openSnackbar({
            //         open: true,
            //         message: error.error,
            //         variant: 'alert',
            //         alert: {
            //             color: 'error'
            //         },
            //         close: true,
            //         anchorOrigin: {
            //             vertical: 'bottom',
            //             horizontal: 'right'
            //         }
            //     })
            // );
        }
    });

    const mSubmitWithdraw = useMutation((data: TWithdrawDataSubmit) => axiosServices.post('/v1/withdraw/withdraw', data), {
        onSuccess(data: any, variables, context) {
            callBack?.(data);
            if (data) {
                dispatch(
                    openSnackbar({
                        open: true,
                        message: 'Withdraw submit order successfully',
                        variant: 'alert',
                        alert: {
                            color: 'success'
                        },
                        close: true,
                        anchorOrigin: {
                            vertical: 'bottom',
                            horizontal: 'right'
                        }
                    })
                );
            } else {
                dispatch(
                    openSnackbar({
                        open: true,
                        message: 'Withdraw submit order Failed',
                        variant: 'alert',
                        alert: {
                            color: 'error'
                        },
                        close: true,
                        anchorOrigin: {
                            vertical: 'bottom',
                            horizontal: 'right'
                        }
                    })
                );
            }
        },
        onError(error: any) {
            dispatch(
                openSnackbar({
                    open: true,
                    message: error.error,
                    variant: 'alert',
                    alert: {
                        color: 'error'
                    },
                    close: true,
                    anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'right'
                    }
                })
            );
        }
    });

    const qGetSubUserWithMerchant = useQuery(
        [`qGetTokenWithUser_${merchantId}_${size}_${page}`, merchantId, page, size],
        () => axiosServices.get(`/v1/merchant/${merchantId}/users?size=${size}&page=${page}`),
        {
            enabled: Boolean(merchantId),
            onSuccess(data: any) {},
            onError(error: any) {}
        }
    );

    // const mGetBalances = useMutation((data: { ids: string[] }) => axiosStagServices.post('/v1/balances/ids', data), {
    //     onSuccess(data: any, variables, context) {
    //         // callBack?.();
    //         // dispatch(
    //         //     openSnackbar({
    //         //         open: true,
    //         //         message: 'Withdraw submit order successfully',
    //         //         variant: 'alert',
    //         //         alert: {
    //         //             color: 'success'
    //         //         },
    //         //         close: true,
    //         //         anchorOrigin: {
    //         //             vertical: 'bottom',
    //         //             horizontal: 'right'
    //         //         }
    //         //     })
    //         // );
    //     },
    //     onError(error: any) {
    //         // dispatch(
    //         //     openSnackbar({
    //         //         open: true,
    //         //         message: error.error,
    //         //         variant: 'alert',
    //         //         alert: {
    //         //             color: 'error'
    //         //         },
    //         //         close: true,
    //         //         anchorOrigin: {
    //         //             vertical: 'bottom',
    //         //             horizontal: 'right'
    //         //         }
    //         //     })
    //         // );
    //     }
    // });

    const qGetPriceUsdBySymbol = useQuery(
        ['qGetPriceUsdBySymbol', symbol],
        () => axiosServices.get(`/v1/public/getPriceUsd?symbol=${symbol}`),
        {
            enabled: Boolean(symbol) && enableGetPrice,
            onSuccess(data: any) {},
            onError(error: any) {}
        }
    );

    const qGenerateAddress = useQuery(
        ['qGenerateAddress', networkId],
        () => axiosServices.get(`/v1/wallet/merchant/generateAddress/${networkId}`),
        {
            enabled: Boolean(networkId),
            onSuccess(data: any) {},
            onError(error: any) {}
        }
    );

    const qGetBalanceBySymbol = useQuery(
        ['qGetBalanceBySymbol', userId, coin],
        () => axiosServices.get(`/v1/wallet/getBalanceBySymbol/${userId}/${coin}`),
        {
            enabled: Boolean(coin) && Boolean(userId),
            onSuccess(data: any) {},
            onError(error: any) {}
        }
    );

    const mSubmitTransferToMerchant = useMutation(
        (data: TTransferDataSubmit) => axiosServices.post('/v1/wallet/transferToMerchant', data),
        {
            onSuccess(data: any, variables, context) {
                callBack?.(data);
                if (data) {
                    qGetBalanceBySymbol.refetch();
                    qGetBalanceSubUser.refetch();
                    qGetFundingSubUser.refetch();
                    dispatch(
                        openSnackbar({
                            open: true,
                            message: 'Transfer successfully',
                            variant: 'alert',
                            alert: {
                                color: 'success'
                            },
                            close: true,
                            anchorOrigin: {
                                vertical: 'bottom',
                                horizontal: 'right'
                            }
                        })
                    );
                } else {
                    dispatch(
                        openSnackbar({
                            open: true,
                            message: 'Transfer failed',
                            variant: 'alert',
                            alert: {
                                color: 'error'
                            },
                            close: true,
                            anchorOrigin: {
                                vertical: 'bottom',
                                horizontal: 'right'
                            }
                        })
                    );
                }
            },
            onError(error: any) {
                dispatch(
                    openSnackbar({
                        open: true,
                        message: error.error,
                        variant: 'alert',
                        alert: {
                            color: 'error'
                        },
                        close: true,
                        anchorOrigin: {
                            vertical: 'bottom',
                            horizontal: 'right'
                        }
                    })
                );
            }
        }
    );
    const qGetSubUserIdOfMerchant = useQuery(
        ['qGetSubUserIdOfMerchant', merchantId],
        () => axiosServices.get(`/v1/wallet/getSubUserIdOfMerchant`),
        {
            enabled: Boolean(merchantId),
            onSuccess(data: any) {}
            // onError(error: any) {}
        }
    );
    return {
        qGetFunding,
        qGetFundingData: qGetFunding?.data?.pages?.[0]?.data?.content as Wallet[],
        qGetFundingSubUser,
        qGetFundingSubUserData: qGetFundingSubUser?.data?.data?.content as Wallet[],
        qPaginationFundingSubUser: qGetFundingSubUser?.data?.data,
        qGetBalance,
        qGetBalanceData: qGetBalance?.data?.data as TGetBalance,
        qPaginationFunding: qGetFunding?.data?.pages?.[0]?.data as Pagination | null,
        qGetInfoWithdraw,
        dataInforWithdraw: qGetInfoWithdraw?.data?.data as TInforWithdraw,
        qGetAddress,
        dataAddress: qGetAddress?.data?.data,
        mSubmitWithdraw,
        mGetAddress,
        dataGetAddress: mGetAddress?.data?.data,
        qGetSubUserWithMerchant,
        qGetSubUserWithMerchantData: qGetSubUserWithMerchant?.data?.data?.content as ISubUser[],
        qPagiantionSubUser: qGetSubUserWithMerchant?.data?.data,
        qGetBalanceSubUser,
        qGetBalanceSubUserData: qGetBalanceSubUser?.data?.data as TGetBalance,
        // mGetBalances,
        // dataBalances: mGetBalances?.data?.data?.data as TBalancesSubUser[],
        qGetPriceUsdBySymbol,
        dataPriceUsdBySymbol: qGetPriceUsdBySymbol?.data?.data as number,
        qGenerateAddress,
        dataGenerateAddress: qGenerateAddress?.data?.data as TNewAddress,
        qGetBalanceBySymbol,
        gGetBalanceBySymbolData: qGetBalanceBySymbol?.data?.data as TSubUserBalance,
        gGetBalanceBySymbolDefaultData: qGetBalanceBySymbol?.data?.data as TSubUserBalance,
        mSubmitTransferToMerchant,
        qGetSubUserIdOfMerchant,
        gGetSubUserIdOfMerchantData: qGetSubUserIdOfMerchant?.data?.data as TSubUserIdOfMerchant
    };
};

export default useWalletApi;
